import { REACTION_OPTIONS } from "../../../ui/reactions/reactionKinds";

const CHAT_EXTRA_REACTION_EMOJIS = ["👍", "😂", "😮", "🙏", "🤩", "⚡", "🎉", "😢", "🗿", "🍌"];

export const REACTION_EMOJIS = Array.from(new Set([
  ...REACTION_OPTIONS.map((item) => item.emoji),
  ...CHAT_EXTRA_REACTION_EMOJIS,
]));

export const EMOJI_CATEGORIES = [
  {
    name: "Улыбки",
    emoji: [
      "😀",
      "😃",
      "😄",
      "😁",
      "😅",
      "😂",
      "🤣",
      "😊",
      "😇",
      "🙂",
      "🙃",
      "😉",
      "😌",
      "😍",
      "🥰",
      "😘",
      "😗",
      "😙",
      "😚",
      "😋",
      "😛",
      "😜",
      "🤪",
      "😝",
      "🤑",
      "🤗",
      "🤭",
      "🤫",
      "🤔",
      "🤐",
      "🤨",
      "😐",
      "😑",
      "😶",
      "🙄",
      "😏",
      "😒",
      "😬",
      "😮",
      "🤥",
      "😔",
      "😪",
      "🤤",
      "😴",
      "😷",
      "🤒",
      "🤕",
      "🤢",
      "🤮",
      "🥴",
      "😵",
      "🤯",
    ],
  },
  {
    name: "Люди",
    emoji: [
      "👋",
      "🤚",
      "🖐",
      "✋",
      "🖖",
      "👌",
      "🤌",
      "🤏",
      "✌",
      "🤞",
      "🤟",
      "🤘",
      "🤙",
      "👈",
      "👉",
      "👆",
      "🖕",
      "👇",
      "☝",
      "👍",
      "👎",
      "✊",
      "👊",
      "🤛",
      "🤜",
      "👏",
      "🙌",
      "👐",
      "🤲",
      "🤝",
      "🙏",
      "✍",
      "💅",
      "🤳",
      "💪",
      "🦾",
      "🦿",
      "🦵",
      "🦶",
      "👂",
      "🦻",
      "👃",
      "🧠",
      "🫀",
      "🫁",
      "🦷",
      "🦴",
      "👀",
      "👁",
      "👅",
      "👄",
    ],
  },
  {
    name: "Символы",
    emoji: [
      "❤️",
      "🧡",
      "💛",
      "💚",
      "💙",
      "💜",
      "🖤",
      "🤍",
      "🤎",
      "💔",
      "❣",
      "💕",
      "💞",
      "💓",
      "💗",
      "💖",
      "💘",
      "💝",
      "💟",
      "☮",
      "✝",
      "☪",
      "🕉",
      "☸",
      "✡",
      "🔯",
      "🕎",
      "☯",
      "☦",
      "🛐",
      "⛎",
      "♈",
      "♉",
      "♊",
      "♋",
      "♌",
      "♍",
      "♎",
      "♏",
      "♐",
      "♑",
      "♒",
      "♓",
      "🆔",
      "⚛",
      "🉑",
      "☢",
      "☣",
    ],
  },
  {
    name: "Животные",
    emoji: [
      "🐱",
      "🐶",
      "🐭",
      "🐹",
      "🐰",
      "🦊",
      "🐻",
      "🐼",
      "🐨",
      "🐯",
      "🦁",
      "🐮",
      "🐷",
      "🐸",
      "🐵",
      "🙈",
      "🙉",
      "🙊",
      "🐒",
      "🐔",
      "🐧",
      "🐦",
      "🐤",
      "🐣",
      "🐥",
      "🦆",
      "🦅",
      "🦉",
      "🦇",
      "🐺",
      "🐗",
      "🐴",
      "🦄",
      "🐝",
      "🐛",
      "🦋",
      "🐌",
      "🐞",
      "🐜",
      "🦟",
      "🦗",
      "🕷",
      "🦂",
      "🐢",
      "🐍",
      "🦎",
      "🦖",
      "🦕",
      "🐙",
    ],
  },
  {
    name: "Еда",
    emoji: [
      "🍕",
      "🍔",
      "🍟",
      "🌭",
      "🍿",
      "🧂",
      "🥓",
      "🥚",
      "🍳",
      "🧇",
      "🥞",
      "🧈",
      "🍞",
      "🥐",
      "🥨",
      "🥯",
      "🥖",
      "🫓",
      "🧀",
      "🥗",
      "🥙",
      "🥪",
      "🌮",
      "🌯",
      "🫔",
      "🥫",
      "🍝",
      "🍜",
      "🍲",
      "🍛",
      "🍣",
      "🍱",
      "🥟",
      "🦪",
      "🍤",
      "🍙",
      "🍚",
      "🍘",
      "🍥",
      "🥠",
      "🥮",
      "🍢",
      "🍡",
      "🍧",
      "🍨",
      "🍦",
      "🥧",
      "🧁",
      "🍰",
      "🎂",
      "🍮",
    ],
  },
  {
    name: "Флаги",
    emoji: [
      "🏁",
      "🚩",
      "🎌",
      "🏴",
      "🏳",
      "🏳️",
      "🏳️‍🌈",
      "🏴‍☠️",
      "🇦🇨",
      "🇦🇩",
      "🇦🇪",
      "🇦🇫",
      "🇦🇬",
      "🇦🇮",
      "🇦🇱",
      "🇦🇲",
      "🇦🇴",
      "🇦🇶",
      "🇦🇷",
      "🇦🇸",
      "🇦🇹",
      "🇦🇺",
      "🇦🇼",
      "🇦🇽",
      "🇦🇿",
      "🇧🇦",
      "🇧🇧",
      "🇧🇩",
      "🇧🇪",
      "🇧🇫",
      "🇧🇬",
      "🇧🇭",
      "🇧🇮",
      "🇧🇯",
      "🇧🇱",
      "🇧🇲",
      "🇧🇳",
      "🇧🇴",
      "🇧🇶",
      "🇧🇷",
      "🇧🇸",
      "🇧🇹",
      "🇧🇻",
      "🇧🇼",
      "🇧🇾",
      "🇧🇿",
      "🇨🇦",
      "🇨🇨",
      "🇨🇩",
    ],
  },
];

export const STICKER_CATEGORIES = [
  {
    name: "Недавние",
    emoji: ["😀", "🥰", "🤗", "😊", "😎", "🥳", "🤔", "😘", "💪", "🙏", "❤️", "🔥", "✨", "🎉", "👏", "🌟"],
  },
  {
    name: "Улыбки",
    emoji: ["😀", "😃", "😄", "😁", "😆", "😅", "🤣", "😂", "🙂", "😉", "😊", "😇", "🥰", "😍", "🤩", "😘"],
  },
  {
    name: "Объятия",
    emoji: ["🤗", "🫂", "🥰", "😍", "🤩", "💕", "💖", "💗", "💓", "💞", "💝", "❤️", "🧡", "💛", "💚", "💙"],
  },
  {
    name: "Поддержка",
    emoji: ["💪", "🙏", "🤝", "👏", "🙌", "✨", "🔥", "💯", "⭐", "🌟", "🏆", "🎯", "💫", "💥", "💢", "❣"],
  },
];
